import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Consegna ")
const _hoisted_2 = { class: "p-inputgroup" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" })
], -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  class: "p-my-2"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "p-text-center" }, " Indirizzo esterno alla città selezionata, o zona non attiva. ", -1)
const _hoisted_7 = { class: "p-d-flex p-jc-between p-mt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Message = _resolveComponent("Message")!
  const _component_PickerSummary = _resolveComponent("PickerSummary")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_EntityPickerDialog = _resolveComponent("EntityPickerDialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Card, { class: "p-mb-3" }, {
      title: _withCtx(() => [
        _hoisted_1
      ]),
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_AutoComplete, {
            ref: "autocompleteRef",
            completeOnFocus: "",
            modelValue: _ctx.searchBox,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.searchBox = $event)),
            suggestions: _ctx.suggestions,
            field: "name",
            minLength: 1,
            placeholder: "Cerca punto di consegna",
            onItemSelect: _ctx.onSelect,
            onComplete: _ctx.search,
            onKeyup: _withKeys(_ctx.onEnter, ["enter"])
          }, {
            item: _withCtx(({item}) => [
              _createElementVNode("strong", null, _toDisplayString(item.name), 1),
              (item.address)
                ? (_openBlock(), _createElementBlock("i", _hoisted_4, " - " + _toDisplayString(item.address), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["modelValue", "suggestions", "onItemSelect", "onComplete", "onKeyup"]),
          _withDirectives(_createVNode(_component_Button, {
            icon: "pi pi-plus",
            label: "Nuovo",
            onClick: _ctx.onNew
          }, null, 8, ["onClick"]), [
            [
              _directive_tooltip,
              _ctx.$t('new'),
              void 0,
              { bottom: true }
            ]
          ])
        ])
      ]),
      _: 1
    }),
    (_ctx.selected)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.isServed === false)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_Message, {
                  class: "p-text-center",
                  severity: "error"
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_PickerSummary, {
            type: "consegna",
            picker: _ctx.pickerSummary,
            savePicker: _ctx.savePicker,
            "onUpdate:savePicker": _cache[1] || (_cache[1] = ($event: any) => (_ctx.savePicker = $event))
          }, null, 8, ["picker", "savePicker"])
        ], 64))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_router_link, { to: _ctx.prevRoute }, {
        default: _withCtx(() => [
          _createVNode(_component_Button, {
            label: "Indietro",
            icon: "pi pi-chevron-left",
            class: "p-button-secondary"
          })
        ]),
        _: 1
      }, 8, ["to"]),
      _createVNode(_component_Button, {
        label: "Avanti",
        icon: "pi pi-chevron-right",
        disabled: !_ctx.selected || !_ctx.isServed,
        onClick: _ctx.goNext
      }, null, 8, ["disabled", "onClick"])
    ]),
    _createVNode(_component_EntityPickerDialog, {
      zone: _ctx.zone,
      pickerType: _ctx.pickerType,
      entityId: _ctx.customer.id,
      visible: _ctx.displayPickerDialog,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => (_ctx.displayPickerDialog = $event)),
      emitOnly: true,
      onNewPicker: _ctx.onSaveNewPicker
    }, null, 8, ["zone", "pickerType", "entityId", "visible", "onNewPicker"])
  ]))
}